module.exports = __webpack_public_path__ + "img/Fliegen.cafd9333.jpg";